import TextButton from 'components/TextButton'
import { View } from 'components/View'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import './index.scss'

class DropdownText extends React.Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.state = {
      hasVisibleContent: false
    }
  }

  handleClick () {
    this.toggleHasVisibleContent()
  }

  toggleHasVisibleContent () {
    this.setState({
      hasVisibleContent: !this.state.hasVisibleContent
    })
  }

  renderContent () {
    return (
      <View
        py
      >
        {this.props.children}
      </View>
    )
  }

  renderTitle () {
    return (
      <View
        style={{
          alignItems: View.ALIGN.START
        }}
      >
        <TextButton
          height='auto'
          onClick={this.handleClick}
          textStyle={this.props.textStyle}
          style={{
            marginTop: STYLES_MARGIN.SMALLEST
          }}
        >
          {this.props.title}
        </TextButton>
      </View>
    )
  }

  render () {
    return (
      <div
        style={{
          transition: 'max-height 0.200s linear',
          maxHeight: this.state.hasVisibleContent ? '40em' : '2em',
          overflow: 'hidden'
        }}
        className='dropdownText'
      >
        {this.renderTitle()}
        {this.renderContent()}
      </div>
    )
  }
}

DropdownText.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  textStyle: PropTypes.object
}
export default DropdownText
